<template>
    <Card>
        <portal to="portal_toolbar" :order="2">
            <button
                class="btn btn-fixed-height btn-bg-white btn-text-dark-50 btn-hover-primary btn-icon-primary font-weight-bolder font-size-sm px-5 my-1"
                @click="selectLastYear">
            <span class="svg-icon svg-icon-md">
                <i class="fas fa-calendar-alt"></i>
            </span>
                Letztes Jahr
            </button>
            <button
                class="btn btn-fixed-height btn-bg-white btn-text-dark-50 btn-hover-primary btn-icon-primary font-weight-bolder font-size-sm px-5 my-1"
                @click="selectLastMonth">
            <span class="svg-icon svg-icon-md">
                <i class="fas fa-arrow-circle-left"></i>
            </span>
                Letzter Monat
            </button>
            <button
                class="btn btn-fixed-height btn-bg-white btn-text-dark-50 btn-hover-primary btn-icon-primary font-weight-bolder font-size-sm px-5 my-1"
                @click="selectThisMonth">
            <span class="svg-icon svg-icon-md">
                <i class="fas fa-arrow-circle-down"></i>
            </span>
                Aktueller Monat
            </button>
            <button
                class="btn btn-fixed-height btn-bg-white btn-text-dark-50 btn-hover-primary btn-icon-primary font-weight-bolder font-size-sm px-5 my-1"
                @click="selectThisYear">
            <span class="svg-icon svg-icon-md">
                <i class="fas fa-calendar"></i>
            </span>
                Dieses Jahr
            </button>
        </portal>

        <date-picker
            v-if="dateRange"
            v-model="dateRange"
            :max-date="today"
            ref="picker"
            color="purple"
            is-expanded
            show-weeknumbers
            is-range
            :columns="$screens({ default: 1, md: 2, xl: 3 })"
            @input="dateSelected"
        />
        <div class="d-flex mt-3 bg-primary py-5 px-4 text-white rounded text-xl font-weight-bolder">
            <div class="col-6">
                {{ $localDate(dateRange.start) }} - {{ $localDate(dateRange.end) }}
            </div>
            <div class="col-6 text-right">
                <span class="opacity-75">{{ (allUserTotal * 0.015).toFixed(2) }}€ |</span> {{
                    allUserTotal.toFixed(2)
                }}€
            </div>
        </div>
        <div class="mt-3 px-4">
            <users-sales-overview
                v-for="(user, i) in users"
                :key="user.firebase_uid"
                :user="user"
                :start="dateRange.start"
                :end="dateRange.end"
                :class="{'mt-2': i>0}"
                class="bg-white rounded"
            />
            <div v-show="users.length === 0" class="text-center text-muted">Keine Ergebnisse für diesen Zeitraum</div>
        </div>
    </Card>
</template>

<script>
import UsersSalesOverview from '@components/User/UsersSalesOverview.vue'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import Card from '@components/Cards/Card.vue'

export default {
    components: {
        Card,
        DatePicker,
        UsersSalesOverview,
    },

    data() {
        return {
            dateRange: null,
            users: [],
        }
    },

    mounted() {
        this.selectThisMonth();
    },

    methods: {
        dateSelected(date) {
            this.loadData(date.start, date.end)
        },

        loadData(startDate, endDate) {
            axios.get(this.$route('reports.sales.data', {
                start: startDate.toISOString(),
                end: endDate.toISOString(),
            })).then(response => {
                this.users = response.data.data
            }).catch(error => {
                this.users = []
            })
        },

        selectLastYear() {
            this.dateRange = {
                start: new Date(this.today.getFullYear() - 1, 0, 1),
                end: new Date(this.today.getFullYear(), 0, 0),
            }
            this.dateSelected(this.dateRange)
        },

        selectThisYear() {
            this.dateRange = {
                start: new Date(this.today.getFullYear(), 0, 1),
                end: new Date(),
            }
            this.dateSelected(this.dateRange)
        },

        selectLastMonth() {
            this.dateRange = {
                start: new Date(this.today.getFullYear(), this.today.getMonth() - 1),
                end: new Date(this.today.getFullYear(), this.today.getMonth(), 0),
            }
            this.dateSelected(this.dateRange)
        },

        selectThisMonth() {
            this.dateRange = {
                start: new Date(this.today.getFullYear(), this.today.getMonth()),
                end: new Date(),
            }
            this.dateSelected(this.dateRange)
        },
    },

    computed: {
        allUserTotal() {
            return this.users.reduce((a, b) => {return a + b.total}, 0)
        },

        today(){
            return new Date();
        }
    },
}
</script>
